import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';
import { debounce } from '@chatwoot/utils';

const state = {
  mineCount: 0,
  collaboratingCount: 0,
  unAssignedCount: 0,
  allCount: 0,
};

export const getters = {
  getStats: $state => $state,
};

// Create a debounced version of the actual API call function
let requestId = 0;

const fetchMetaData = async (commit, params, isCurrent) => {
  if (!isCurrent()) return;
  try {
    const response = await ConversationApi.meta(params);
    const {
      data: { meta },
    } = response;
    if (isCurrent()) commit(types.SET_CONV_TAB_META, meta);
  } catch (error) {
    // ignore
  }
};

const debouncedFetchMetaData = debounce(fetchMetaData, 500, false, 1500);
const longDebouncedFetchMetaData = debounce(fetchMetaData, 5000, false, 10000);
const superLongDebouncedFetchMetaData = debounce(
  fetchMetaData,
  10000,
  false,
  20000
);

export const actions = {
  get: async ({ commit, state: $state, rootGetters }, params) => {
    requestId += 1;
    const id = requestId;
    const accountId = ConversationApi.accountIdFromRoute;
    const userId = rootGetters?.getCurrentUserID;
    const isCurrent = () =>
      id === requestId &&
      accountId === ConversationApi.accountIdFromRoute &&
      userId === rootGetters?.getCurrentUserID;
    if ($state.allCount > 5000) {
      superLongDebouncedFetchMetaData(commit, params, isCurrent);
    } else if ($state.allCount > 100) {
      longDebouncedFetchMetaData(commit, params, isCurrent);
    } else {
      debouncedFetchMetaData(commit, params, isCurrent);
    }
  },
  set({ commit }, meta) {
    requestId += 1;
    commit(types.SET_CONV_TAB_META, meta);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      collaborating_count: collaboratingCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
    } = {}
  ) {
    $state.mineCount = mineCount;
    $state.collaboratingCount = collaboratingCount || 0;
    $state.allCount = allCount;
    $state.unAssignedCount = unAssignedCount;
    $state.updatedOn = new Date();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
